import { IDR } from '@/libs/currency'
import { defaultThClass } from '../../../../config'

const defaultClass = {
  tdClass: '!font-[400] text-[#333333] !align-top',
  class: `${defaultThClass} !text-[14px] !min-w-[180px] !text-[#333333] !align-middle`,
}

export const fieldsDetailProduct = [
  {
    key: 'no',
    label: 'No',
    thClass: '!w-[60px]',
  },
  {
    key: 'awb',
    label: 'Nomor Resi',
    thClass: '!min-w-[180px]',
  },
  {
    key: 'products',
    label: 'Produk',
    thClass: '!min-w-[200px]',
  },
  {
    key: 'total_item',
    label: 'Jumlah Item',
    thClass: '!w-[120px]',
  },
  {
    key: 'packings',
    label: 'Bahan Packing',
    thClass: '!min-w-[180px]',
  },
  {
    key: 'status',
    label: 'Status',
    thClass: '!w-[160px]',
  },
  {
    key: 'fulfillment_fee_per_order',
    label: 'Biaya Fulfillment',
    thClass: '!min-w-[160px]',
    formatter: value => IDR(value),
  },
]

export const fieldsDetailBundling = [
  {
    key: 'product_name',
    label: 'Nama Produk',
    thClass: `${defaultClass.class} !min-w-[200px] !text-sm`,
    tdClass: defaultClass.tdClass,
  },
  {
    key: 'qty',
    label: 'Jumlah',
    thClass: `${defaultClass.class} !text-sm !min-w-[40px]`,
    tdClass: defaultClass.tdClass,
  },
]

/**
 * Handle status classes
 * @param {string} status - Status fulfillment
 * @returns {string} CSS class sesuai status
 */
export const handleStatusClasses = status => {
  if (status === 'Dibatalkan' || status === 'canceled') return 'text-[#E31A1A] bg-[#FFEDED]'
  if (status === 'Dipacking' || status === 'confirmed') return 'text-[#4285F4] bg-[#DFF3FF]'
  return 'text-[#FBA63C] bg-[#FFF2E2]/90'
}

export const statusMapping = {
  Unknown: {
    label: 'Unknown',
    color: {
      main: '#000000',
      sub: '#E2E2E2',
    },
  },
  'Belum Dipacking': {
    label: 'Belum Dipacking',
    color: {
      main: '#4285F4',
      sub: '#D9E7FD',
    },
  },
  submitted: {
    label: 'Belum Dipacking',
    color: {
      main: '#4285F4',
      sub: '#D9E7FD',
    },
  },
  Diajukan: {
    label: 'Belum Dipacking',
    color: {
      main: '#4285F4',
      sub: '#D9E7FD',
    },
  },
  Dipacking: {
    label: 'Dipacking',
    color: {
      main: '#FBA63C',
      sub: '#FFF2E2',
    },
  },
  confirmed: {
    label: 'Dipacking',
    color: {
      main: '#FBA63C',
      sub: '#FFF2E2',
    },
  },
  'Menunggu Pickup': {
    label: 'Menunggu Pickup',
    color: {
      main: '#FBBC05',
      sub: '#FEF2CD',
    },
  },
  Dikirim: {
    label: 'Terkirim',
    color: {
      main: '#34A770',
      sub: '#DCF3EB',
    },
  },
  Dibatalkan: {
    label: 'Dibatalkan',
    color: {
      main: '#E31A1A',
      sub: '#FFEDED',
    },
  },
  canceled: {
    label: 'Dibatalkan',
    color: {
      main: '#E31A1A',
      sub: '#FFEDED',
    },
  },
}
